<template>
  <div
    :class="customClass"
    class="d-flex justify-content-between align-items-center border-bottom px-3 py-2 text-main "
  >
    <section class="d-flex w-100 align-items-center">
      <i class="material-icons align-middle smaller">
        {{ icon }}
      </i>
      <small class="text-uppercase font-weight-bold mx-1">
        {{ title }}
      </small>
      <slot name="nav-subtitle-extra-title"></slot>
    </section>
    <section v-if="points">
      <span class="font-weight-bold">
        {{ points }}
      </span>
      <b-img
        :src="require('@/assets/icons/icon-money-star.png')"
        class="icon-star-small h-auto"
      ></b-img>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    icon: String,
    points: Number,
    customClass: String
  }
};
</script>
